/*
 *
 * Session reducer
 *
 */

import {
  VERIFY_SESSION_SUCCESS,
  VERIFY_SESSION_ERROR,
  LOG_IN_SUCCESS,
  LOG_IN_ERROR,
  LOG_OUT_SUCCESS,
  LOG_OUT_ERROR,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_SUCCESS,
  OTP_APPROVE_SUCCESS,
  OTP_APPROVE_ERROR,
} from "./constants";

const initialState = {
  loading: false,
  success: false,
  error: false,
  loggedIn: true,
  metaData: {},
  user: {},
};

/**
 * @param {object} state
 * @param {object} action
 */
const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOG_IN_SUCCESS:
    case VERIFY_SESSION_SUCCESS:
      return {
        ...state,

        loading: false,
        success: false,
        error: false,
        loggedIn: true,
        user: action.user,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: false,
        error: false,
        loggedIn: true,
        reset_Password: action.reset_Password,
      };
    case OTP_APPROVE_SUCCESS:
      return {
        loading: false,
        success: false,
        error: false,
        loggedIn: true,
        otp_approve: action.otp_approve,
      };
    case VERIFY_SESSION_ERROR:
    case LOG_IN_ERROR:
    case FORGOT_PASSWORD_ERROR:
      return {
        loading: false,
        success: false,
        error: action.errorfalse,
        loggedIn: false,
        user: false,
      };
    case RESET_PASSWORD_ERROR:
      return {
        loading: false,
        success: false,
        error: false,
        loggedIn: true,
        reset_Password: false,
      };
    case OTP_APPROVE_ERROR:
      return {
        loading: false,
        success: false,
        error: false,
        loggedIn: true,
        otp_approve: false,
      };
    case LOG_OUT_ERROR:
    case LOG_OUT_SUCCESS:
      return {
        loading: false,
        success: false,
        error: false,
        loggedIn: false,
        user: false,
      };
    default:
      return state;
  }
};

export default sessionReducer;
